import { contractList, factoryContractList, privateList } from '@/api/staking/read';
import { useWeb3 } from '@/hooks/use-web3';
import { ResPrivateListType } from '@/types/staking/read';
import { createContext, useEffect, useState, type ReactNode } from 'react';

export interface ContractPoolType {
  factoryPools: string[];
  contractPools: string[];
  privates: ResPrivateListType[] | null;
  isLoading: boolean;
  error: string | null;
}
export const ContractPoolContext = createContext<ContractPoolType | undefined>(undefined);

export function ContractPoolProvider({ children }: { children: ReactNode }) {
  const { web3authCall } = useWeb3();
  const [factoryPools, setFactoryPools] = useState<string[]>([]);
  const [contractPools, setContractPools] = useState<string[]>([]);
  const [privates, setPirvates] = useState<ResPrivateListType[] | null>(null);
  const [isLoading] = useState(false);
  const [error] = useState<string | null>(null);

  useEffect(() => {
    (async () => {
      if (web3authCall) {
        await connectWeb3auth();
      }
    })();
    return () => {};
  }, [web3authCall]);

  const connectWeb3auth = async () => {
    const factoryList = await factoryContractList();
    if (!factoryList.data) {
      return;
    }
    for (const iter of factoryList.data) {
      web3authCall!.getStakingCall().setContractFactory(iter.contractAddr);
    }

    const contracts = await contractList();
    if (!contracts.data) {
      return;
    }
    web3authCall!.getStakingCall().setStakingContract(contracts.data);
    setFactoryPools(factoryList.data);
    setContractPools(contracts.data.pool_contract_addr);

    const privates = await privateList();
    if (!privates.data) {
      return;
    }

    setPirvates(privates.data);
  };
  return (
    <ContractPoolContext.Provider value={{ contractPools, factoryPools, privates, isLoading, error }}>
      {children}
    </ContractPoolContext.Provider>
  );
}
